module.exports = "/_next/static/images/bocongthuong-867d8e1af42666790ea3b2f1d70ed3db.png";